import { render, staticRenderFns } from "./CSVsus.vue?vue&type=template&id=8b6cf74e&scoped=true"
import script from "./CSVsus.vue?vue&type=script&lang=js"
export * from "./CSVsus.vue?vue&type=script&lang=js"
import style0 from "./CSVsus.vue?vue&type=style&index=0&id=8b6cf74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6cf74e",
  null
  
)

export default component.exports